export default __webpack_public_path__ + "static/media/colorsb.128a7519.svg";